import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import PageMeta from "../common/PageMeta";
import PageBreadcrumb from "../common/PageBreadCrumb";
import ComponentCard from "../common/ComponentCard";
import Pagination from "../common/Pagination";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "../ui/table";
import {
  TrashBinIcon,
  PhoneIcon,
  PencilIcon
} from "../../icons";
import { Link } from "react-router";
import Badge from "../ui/badge/Badge";
import { checkAuth, getAllCustomers, deleteUserById, emptyReduxUser } from "../../actions/userAction";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../helpers/userAuth';
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { configPaths } from '../../config';

export default function AllPlans() {

  dayjs.extend(relativeTime);

  const perpage = configPaths.recordsPerPage;

  const navigate = useNavigate();
  
  const dispatch = useDispatch();

  const [customerData, setCustomerData] = useState([]);

  const [loadData, setLoadData] = useState(true);

  const getAllCustomerRes = useSelector(state => state.userReducer.getAllCustomer);

  const getAllCustomerFailed = useSelector(state => state.userReducer.getAllCustomerFailed);

  const checkAuthFailed = useSelector(state => state.userReducer.checkAuthFailed);

  const [showModal, setShowModal] = useState(false);
  
  const [customerToDelete, setCustomerToDelete] = useState(null);

  const [totalRecords, setTotalRecords] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  
  useEffect(() => {
    dispatch(checkAuth());
    dispatch(getAllCustomers(perpage, 1));
  }, []);

  useEffect(() => {
      if(checkAuthFailed.statusCode == 401){
        dispatch(emptyReduxUser());
        logout();
        navigate("/signin");
      }

  }, [checkAuthFailed]); 

  
  useEffect(() => {
      
    if(typeof getAllCustomerRes != "undefined" && getAllCustomerRes.statusCode == 200){
      let data = [];

      let customerslist = getAllCustomerRes.data.users;
      const customersData = customerslist.map((item) => {
              return {
                "id": item.id,
                "firstName": item.firstName,
                "lastName": item.lastName,
                "phone": item.phone,
                "phone2": item.phone2,
                "address1": item.address1,
                "address2": item.address2,
                "city": item.city,
                "state": item.state,
                "country": item.country,
                "pinCode": item.pinCode,
                "updatedAt": item.updatedAt,
                "userId": item.userId,
              };
      });

      console.log("planData", customersData);

      setLoadData(false);

      setCustomerData([
          ...customersData
      ]);

      setTotalRecords(getAllCustomerRes.data.count);

    }

  }, [getAllCustomerRes]);

  useEffect(() => {
      //console.log(getAllCustomerFailed);
      if(getAllCustomerFailed.statusCode == 401 || getAllCustomerFailed.statusCode == 500){

            //toast.error(getAllCustomerFailed.message, {autoClose:2000,onClose: () => {

                  //logout();
                  //navigate("/signin");
            //}});
            setLoadData(false);
      }
    }, [getAllCustomerFailed]);

    const handleDeleteClick = (userId) => {
      setCustomerToDelete(userId);
      setShowModal(true);  // Show the confirmation modal
    };

    const handleConfirmDelete = () => {
      dispatch(deleteUserById(customerToDelete));
      setCustomerData(customerData.filter(c => c.userId !== customerToDelete));  // Remove the deleted plan from the state
      setShowModal(false);  // Close the modal
      toast.success("Customer deleted successfully", {
        position: "bottom-right",
        autoClose: 4000,
      });
    };

    const handleCancelDelete = () => {
      setShowModal(false);  // Close the modal without doing anything
    };

    const handlePgNav = (typ) => {
      let pgNum = typ === "next" ? currentPage + 1 : currentPage - 1;

      if(pgNum < 1 || pgNum > Math.ceil(totalRecords / perpage)){
        return;
      }

      setCurrentPage(pgNum);
      setLoadData(true);
      dispatch(getAllCustomers(perpage, pgNum));
    };
  
    const handleChangePg = (pgNum) => {
      if(!isNaN(pgNum) && pgNum !== currentPage){
        setCurrentPage(pgNum);
        setLoadData(true);
        dispatch(getAllCustomers(perpage, pgNum));
      }
    };

  return (
    <>
      <PageMeta
        title="Customers List | Chit Fund Management System"
        description="Chit Fund Management System"
      />
      <PageBreadcrumb pageTitle="Customers" />
      <div className="space-y-6">
        <ComponentCard title="All customers list" btn="/customer/add">
          <div className="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-white/[0.05] dark:bg-white/[0.03]">
            <div className="max-w-full overflow-x-auto">
              <div className="min-w-[1102px]">
                <Table>
                  {/* Table Header */}
                  <TableHeader className="border-b border-gray-100 dark:border-white/[0.05]">
                    <TableRow>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Name
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Phone
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Address
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        city
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        State
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Country
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        pinCode
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHeader>

                  {/* Table Body */}
                  <TableBody className="divide-y divide-gray-100 dark:divide-white/[0.05]">
                    {
                      customerData.length > 0

                      ?

                      customerData.map((item) => (
                      <TableRow key={item.id}>
                        <TableCell className="px-5 py-4 sm:px-6 text-start">
                          <div className="flex items-center gap-3">
                            <div>
                              <span className="block font-medium text-gray-800 text-theme-sm dark:text-white/90">
                              {item.firstName} {item.lastName}
                              </span>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                        {item.phone}<br />{item.phone2}
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                        {item.address1}<br />{item.address2}
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                          {item.city}
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                          {item.state}
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                          {item.country}
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                          {item.pinCode}
                        </TableCell>
                        <TableCell className="text-center px-4 py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                        <div className="flex flex-cols-2 gap-6 xl:grid-cols-2">
                            <div className="space-y-6">
                            <Link
                              to={"/customer/edit/"+item.userId}
                              className="text-indigo-600 ring-1 ring-indigo-200 ring-inset hover:ring-indigo-300 shadow-xs focus-visible:outline-indigo-500 rounded-md px-2.5 py-2.5 text-center text-sm inline-block"
                            >
                              <PencilIcon />
                            </Link>
                            </div>
                            <div className="space-y-6">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleDeleteClick(item.userId)}
                              className="text-indigo-600 ring-1 ring-indigo-200 ring-inset hover:ring-indigo-300 shadow-xs focus-visible:outline-indigo-500 rounded-md px-2.5 py-2.5 text-center text-sm inline-block"
                            >
                              <TrashBinIcon />
                            </Link>
                            </div>
                          </div>
                        </TableCell>
                      </TableRow>
                      
                    ))
                    :
                    <TableRow>
                      <td colSpan={8} className="text-center py-6 text-gray-500">{(loadData === true ? "Loading..." : "No Records Found..!" )}</td>
                    </TableRow>
                  }
                  </TableBody>
                </Table>
              </div>

              {/* Pagination */}
              {
                customerData.length > 0 
                ?
                <Pagination
                  totalRecords={totalRecords}
                  perPage={perpage}
                  currentPage={currentPage}
                  handlePgNav={handlePgNav}
                  handleChangePg={handleChangePg}
                />
                :
                null
              }

            </div>
          </div>
        </ComponentCard>
      </div>
      {/* Custom Confirmation Modal using Tailwind CSS */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
            <h3 className="text-lg font-semibold text-gray-700">Confirm Deletion</h3>
            <p className="text-gray-600 mt-2">Are you sure you want to delete this Customer?</p>
            <div className="mt-4 flex justify-end gap-4">
              <button
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
                onClick={handleCancelDelete}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                onClick={handleConfirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
      {/*<div className="relative isolate bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div aria-hidden="true" className="absolute inset-x-0 -top-3 -z-10 transform-gpu overflow-hidden px-36 blur-3xl">
          <div
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
            className="mx-auto aspect-1155/678 w-[72.1875rem] bg-linear-to-tr from-[#ff80b5] to-[#9089fc] opacity-30"
          />
        </div>
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="text-base/7 font-semibold text-indigo-600">Pricing</h2>
          <p className="mt-2 text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-6xl">
            Choose the right plan for you
          </p>
        </div>
        <p className="mx-auto mt-6 max-w-2xl text-center text-lg font-medium text-pretty text-gray-600 sm:text-xl/8">
          Choose an affordable plan that’s packed with the best features for engaging your audience, creating customer
          loyalty, and driving sales.
        </p>
        <div className="mx-auto mt-16 grid max-w-lg grid-cols-1 items-center gap-y-6 sm:mt-20 sm:gap-y-0 lg:max-w-4xl lg:grid-cols-2">
          {tiers.map((tier, tierIdx) => (
            <div
              key={tier.id}
              className={classNames(
                tier.featured ? 'relative bg-gray-900 shadow-2xl' : 'bg-white/60 sm:mx-8 lg:mx-0',
                tier.featured
                  ? ''
                  : tierIdx === 0
                    ? 'rounded-t-3xl sm:rounded-b-none lg:rounded-tr-none lg:rounded-bl-3xl'
                    : 'sm:rounded-t-none lg:rounded-tr-3xl lg:rounded-bl-none',
                'rounded-3xl p-8 ring-1 ring-gray-900/10 sm:p-10',
              )}
            >
              <h3
                id={tier.id}
                className={classNames(tier.featured ? 'text-indigo-400' : 'text-indigo-600', 'text-base/7 font-semibold')}
              >
                {tier.name}
              </h3>
              <p className="mt-4 flex items-baseline gap-x-2">
                <span
                  className={classNames(
                    tier.featured ? 'text-white' : 'text-gray-900',
                    'text-5xl font-semibold tracking-tight',
                  )}
                >
                  {tier.priceMonthly}
                </span>
                <span className={classNames(tier.featured ? 'text-gray-400' : 'text-gray-500', 'text-base')}>/month</span>
              </p>
              <p className={classNames(tier.featured ? 'text-gray-300' : 'text-gray-600', 'mt-6 text-base/7')}>
                {tier.description}
              </p>
              <ul
                role="list"
                className={classNames(
                  tier.featured ? 'text-gray-300' : 'text-gray-600',
                  'mt-8 space-y-3 text-sm/6 sm:mt-10',
                )}
              >
                {tier.features.map((feature) => (
                  <li key={feature} className="flex gap-x-3">
                    
                    {feature}
                  </li>
                ))}
              </ul>
              <a
                href={tier.href}
                aria-describedby={tier.id}
                className={classNames(
                  tier.featured
                    ? 'bg-indigo-500 text-white shadow-xs hover:bg-indigo-400 focus-visible:outline-indigo-500'
                    : 'text-indigo-600 ring-1 ring-indigo-200 ring-inset hover:ring-indigo-300 focus-visible:outline-indigo-600',
                  'mt-8 block rounded-md px-3.5 py-2.5 text-center text-sm font-semibold focus-visible:outline-2 focus-visible:outline-offset-2 sm:mt-10',
                )}
              >
                Get started today
              </a>
            </div>
          ))}
        </div>
      </div>*/}
    </>
  );
}